import { Chip } from '@heroui/react';
import { ILessonFormat } from '@/shared/types/lesson';

const getFormatDisplayLabel = (format?: ILessonFormat | null): string => {
  if (format !== undefined && format !== null) {
    return format.charAt(0).toUpperCase() + format.slice(1);
  }
  return '—';
};

const getFormatChipClass = (format?: ILessonFormat | null) => {
  if (format === ILessonFormat.Online) {
    return 'bg-[#CFF7D3] text-green-tertiary';
  }
  if (format === ILessonFormat.Offline) {
    return 'bg-[#DBEAFE] text-[#1447E6]';
  }
  if (format === ILessonFormat.Meeting) {
    return 'bg-[#FFE8A3] text-yellow-tertiary';
  }
  return 'bg-gray-100 text-gray-700';
};

interface LessonFormatProps {
  format?: ILessonFormat | null;
}

export const LessonFormat = ({ format }: LessonFormatProps) => (
  <Chip size="md" variant="flat" className={getFormatChipClass(format)}>
    {getFormatDisplayLabel(format)}
  </Chip>
);
